import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LikedIcon, LikeEnabledIcon } from '../icons';
import { Button } from '../ui';
export var JobPostLikeBox = function (_a) {
    var handleLikeJob = _a.handleLikeJob, jobLikedByCurrentUser = _a.jobLikedByCurrentUser, likesCount = _a.likesCount, jobId = _a.jobId, _b = _a.type, type = _b === void 0 ? false : _b, handleLikedPeople = _a.handleLikedPeople, setShowLikedPeople = _a.setShowLikedPeople;
    return (_jsxs("div", { className: 'flex items-center bg-vjwSecondary  px-2 py-1 rounded-lg space-x-2', children: [_jsx(Button, { onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    handleLikeJob(!jobLikedByCurrentUser);
                }, variant: 'text', className: 'px-0 py-0', id: 'liked-job-btn', children: jobLikedByCurrentUser ? _jsx(LikeEnabledIcon, {}) : _jsx(LikedIcon, {}) }), _jsx(Button, { variant: 'text', onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    handleLikedPeople(jobId);
                    setShowLikedPeople(true);
                }, className: "text-sm py-0 px-1 bg-white rounded-md font-medium ".concat(type ? 'text-vjwPrimary' : 'text-gray-700'), children: likesCount })] }));
};
